import { AWB } from '../_types/awb';

export function isStandard(node: AWB.Node): node is AWB.Standard {
  return 'subStandards' in node;
}

export function isSubStandard(node: AWB.Node): node is AWB.SubStandard {
  return 'requirements' in node;
}

export function isRequirement(node: AWB.Node): node is AWB.Requirement {
  return !isStandard(node) && !isSubStandard(node);
}
